module.exports = __webpack_public_path__ + "img/title5.c3d09ffa.png";